import React, { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

const DEFAULT_NOTIFICATIONS = {
    productOffers: 0,
    claims: 0,
};

export const NotificationProvider = ({ children }) => {
    // Храним объект со всеми счетчиками
    const [notifications, setNotificationsState] = useState(DEFAULT_NOTIFICATIONS);

    // Устанавливаем конкретный тип уведомления
    const setNotification = useCallback((type, count) => {
        setNotificationsState(prev => ({
            ...prev,
            [type]: count
        }));
    }, []);

    // Устанавливаем несколько сразу (если нужно)
    const setMultipleNotifications = useCallback((newNotifications) => {
        setNotificationsState(prev => ({
            ...prev,
            ...newNotifications
        }));
    }, []);

    // Инкремент для конкретного типа
    const incrementCount = useCallback((type, amount = 1) => {
        setNotificationsState(prev => ({
            ...prev,
            [type]: (prev[type] || 0) + amount
        }));
    }, []);

    // Декремент для конкретного типа
    const decrementCount = useCallback((type, amount = 1) => {
        setNotificationsState(prev => ({
            ...prev,
            [type]: Math.max(0, (prev[type] || 0) - amount)
        }));
    }, []);

    // Сброс конкретного типа
    const resetCount = useCallback((type) => {
        setNotificationsState(prev => ({
            ...prev,
            [type]: 0
        }));
    }, []);

    // Сброс всех
    const resetAll = useCallback(() => {
        setNotificationsState(DEFAULT_NOTIFICATIONS);
    }, []);

    // Получить общее количество (сумма всех)
    const getTotalCount = useCallback(() => {
        return Object.values(notifications).reduce((sum, val) => sum + val, 0);
    }, [notifications]);

    const value = {
        notifications,          // объект { productOffers: 5, claims: 3 }
        setNotification,        // (type, count) => void
        setMultipleNotifications,
        incrementCount,
        decrementCount,
        resetCount,
        resetAll,
        getTotalCount,
    };

    return (
        <NotificationContext.Provider value={value}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotifications = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotifications must be used within a NotificationProvider');
    }
    return context;
};